import vsComponent from './vsIcon'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
